export const DAMAGE_TYPES = [
    "acid",
    "cold",
    "fire",
    "force",
    "lightning",
    "necrotic",
    "poison",
    "psychic",
    "radiant",
    "thunder",
    "bludgeoning",
    "piercing",
    "slashing"
];